export default __webpack_public_path__ + "static/media/sk.c7a67160.jpeg";